import EventEmitter from '../support/eventemitter';

export class Value extends EventEmitter {
    /**
     *
     * @param {Record} parent
     * @param {GridValue} _gridValue
     */
    constructor (parent, _gridValue) {
        super();

        /**
         * Internal reference to the MVC GridValue object.
         * @type {GridValue}
         */
        this.raw = _gridValue;

        /**
         * Object that should be used for custom logic to prevent breaking the core API
         * @type {Object}
         */
        this.runtime = {};

        /**
         * Create a (circular) reference to this API Value object on the MVC GridValue object.
         * @type {Value}
         */
        _gridValue.apiRef = this;

        this.parent = parent;

        /**
         * Flag to indicate if this object has been disposed or not.
         * @type {boolean}
         */
        this.isDisposed = false;
    }

    get formattedValue () {
        return this.raw.displayProperties.getText();
    }

    get status () {
        return app.dv.entities.gridValue.getStatus(this.raw);
    }

    set status (valueStatus) {
        app.dv.entities.gridValue.setStatus(this.raw, valueStatus);
    }

    get saveIsRequired () {
        return this.raw.isDirty();
    }

    get value () {
        return app.dv.entities.gridValue.getValue(this.raw);
    }

    set value (value) {
        app.dv.entities.gridValue.setValue(this.raw, value);
    }

    get valueID () {
        return this.raw.dynamicValue.TypeValueID;
    }

    async dispose () {
        if (this.isDisposed) {
            return;
        }
        this.raw.apiRef = null;
        this.raw = null;
        this.parent = null;
    }
}
